import Super from './-legacy';

export default class HomeLegacyHome extends Super {}
